<template>
  <main name="organism-create-new-contract">
    <section name="select-customer" class="mb-2 select-customer-container">
      <molecule-select-customer
        :hasCreateCustomerPermission="hasCreateCustomerPermission"
        :isValidateTrigger="isValidateTrigger"
        :customerOption="customerOption"
        :businessTypeOption="businessTypeOption"
        :selectedCustomerDetail="selectedCustomerDetail"
        @onSelectCustomer="onSelectCustomer"
        @onAddNewCustomer="onAddNewCustomer"
        @onUpdateOptionalContractId="onUpdateOptionalContractId"
        @onUpdateErrorAtOptionalIdcId="onUpdateErrorAtOptionalIdcId"
      ></molecule-select-customer>
    </section>

    <section v-if="isSelectedCustomer" name="contract-additional-id">
      <molecule-contract-additional-id
        v-model="currentContractDetail.additionalIds"
        :isEnableAddNew="hasCreatePermission"
        :isDeletable="hasCreatePermission"
      ></molecule-contract-additional-id>
    </section>

    <section
      v-if="isSelectedCustomer"
      name="service-detail"
      class="mb-2 service-detail-container"
    >
      <molecule-service-detail
        v-model="currentContractForWatch"
        :hasEditPermission="hasCreatePermission"
        :serviceOption="serviceOption"
        :locationOption="locationOption"
        :isValidateTrigger="isValidateTrigger"
        :funcGetPackageNameList="funcGetPackageNameList"
        :funcGetServiceAndPackageDetail="funcGetServiceAndPackageDetail"
        :isShowRack="false"
        @onUpdateError="onUpdateErrorInMoleculeServiceDetail"
        @onUpdateGeneralServiceInfo="onUpdateGeneralServiceInfo"
        @onUpdateContractPackages="onUpdateContractPackages"
        @onSelectSite="onSelectSite"
      ></molecule-service-detail>
    </section>

    <section
      v-if="isSelectedCustomer"
      name="contract-note"
      class="mb-2 contract-note-container"
    >
      <molecule-new-contract-note
        v-model="currentContractDetail.notes"
      ></molecule-new-contract-note>
    </section>

    <section
      v-if="isSelectedCustomer"
      name="contact-point"
      class="mb-2 contact-point-container"
    >
      <molecule-contact-point
        :hasEditPermission="hasCreatePermission"
        :contactPointOption="contactPointOption"
        :selectedContactPointId="selectedContactPointId"
        :selectedContactPointDetail="selectedContactPointDetail"
        :locationOption="locationOption"
        :isValidateTrigger="isValidateTrigger"
        @onClearSelectedContactPointId="onClearSelectedContactPointId"
        @onSelectContactPoint="onSelectContactPoint"
        @onUpdateCurrentContactPointList="onUpdateContactPoints"
        @onRequestCreateNewContactPoint="onRequestCreateNewContactPoint"
        @onUpdateContactPointProfilePicture="onUpdateContactPointProfilePicture"
        @onUpdateErrorAtMoleculeContactPoint="
          onUpdateErrorAtMoleculeContactPoint
        "
      ></molecule-contact-point>
    </section>

    <section
      v-if="isSelectedCustomer"
      name="sale-contact"
      class="mb-2 sale-contact-container"
    >
      <molecule-sale-contact
        :hasEditPermission="hasCreatePermission"
        :saleOption="saleOption"
        :selectedSaleContactId="selectedSaleContactId"
        :selectedSaleContactDetail="selectedSaleContactDetail"
        :isValidateTrigger="isValidateTrigger"
        @onClearSelectedSaleContactId="onClearSelectedSaleContactId"
        @onSelectSaleContact="onSelectSaleContact"
        @onUpdateCurrentSaleList="onUpdateSaleContact"
        @onRequestCreateNewSaleContact="onRequestCreateNewSaleContact"
        @onUpdateSaleProfilePicture="onUpdateSaleProfilePicture"
        @onUpdateErrorAtMoleculeSaleContact="onUpdateErrorAtMoleculeSaleContact"
      ></molecule-sale-contact>
    </section>

    <section v-if="isSelectedCustomer" name="contract-escalation" class="mb-2">
      <b-card>
        <molecule-escalation-selection
          v-model="escalationSelected"
          :is-disable-select="!hasCreatePermission || !hasReadTicketEscalationPermission"
          :escalation-template-list="escalationTemplateList"
          :escalation-name="escalationDetail.name"
          :description="escalationDetail.description"
          :levels="escalationDetail.levels"
          :is-show-info="true"
        />
      </b-card>
    </section>

    <section
      v-if="isSelectedCustomer"
      name="button-section"
      class="d-flex justify-content-end"
    >
      <div class="action-button-container d-flex">
        <atom-button
          buttonId="confirm-add-customer-button"
          @click="onClickCreateNewContractButton"
        >
          <span>Create New</span>
        </atom-button>

        <atom-button
          class="ml-1"
          buttonId="cancel-add-customer-button"
          buttonStyle="border"
          buttonColor="secondary"
          @click="onClickCancelButton"
        >
          <span>Cancel</span>
        </atom-button>
      </div>
    </section>

    <footer style="height: 12px"></footer>

    <!-- start confirm create new contract modal -->
    <molecule-modal-dialog
      modalId="modal-confirm-create-new-contract"
      textTitle="Do you want to create new contract ?"
      buttonTextLeft="Create"
      :isTextCenter="true"
      @clickButtonLeft="onClickConfirmCreateNewContractFromModal"
    ></molecule-modal-dialog>
    <!-- end confirm create new contract modal -->
  </main>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeSelectCustomer from "@/components/molecules/portal/idc/MoleculeSelectCustomer.vue"
import MoleculeServiceDetail from "@/components/molecules/portal/idc/MoleculeServiceDetail.vue"
import MoleculeNewContractNote from "@/components/molecules/portal/idc/MoleculeNewContractNote.vue"
import MoleculeContactPoint from "@/components/molecules/portal/idc/MoleculeContactPoint.vue"
import MoleculeSaleContact from "@/components/molecules/portal/idc/MoleculeSaleContact.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixins from "@/mixins"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import MoleculeEscalationSelection from "@/components/molecules/portal/escalationSelection/MoleculeEscalationSelection.vue"
import MoleculeContractAdditionalId from "@/components/molecules/portal/idc/MoleculeContractAdditionalId.vue"
import { BCard } from "bootstrap-vue"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismIdcCreateNewContract",
  components: {
    AtomButton,
    MoleculeSelectCustomer,
    MoleculeServiceDetail,
    MoleculeNewContractNote,
    MoleculeContactPoint,
    MoleculeSaleContact,
    MoleculeModalDialog,
    MoleculeEscalationSelection,
    MoleculeContractAdditionalId,
    BCard,
  },
  props: {
    customerOption: {
      type: Array,
      required: true,
    },
    businessTypeOption: {
      type: Array,
      required: true,
    },
    serviceOption: {
      type: Array,
      required: true,
    },
    locationOption: {
      type: Array,
      required: true,
    },
    contactPointOption: {
      type: Array,
      required: true,
    },
    saleOption: {
      type: Array,
      required: true,
    },
    contactPointDetail: {
      type: Object,
      required: false,
      default: null,
    },
    saleDetail: {
      type: Object,
      required: false,
      default: null,
    },
    selectedCustomerId: {
      type: String,
      required: false,
      default: null,
    },
    selectedCustomerDetail: {
      type: Object,
      required: false,
      default: () => {},
    },
    selectedContactPointId: {
      type: String,
      required: false,
      default: null,
    },
    selectedContactPointDetail: {
      type: Object,
      required: false,
      default: null,
    },
    selectedSaleContactId: {
      type: String,
      required: false,
      default: null,
    },
    selectedSaleContactDetail: {
      type: Object,
      required: false,
      default: null,
    },
    funcGetPackageNameList: {
      type: Function,
      required: true,
      default: () => {},
    },
    funcGetServiceAndPackageDetail: {
      type: Function,
      required: true,
      default: () => {},
    },
    // value: {
    //   type: Object,
    //   required: true,
    // },
    escalationTemplateList: {
      type: Array,
      required: true,
    },
    escalation: {
      type: Object,
      required: false,
      default: () => {},
    },
    escalationDetail: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  emits: [
    "onSelectCustomer",
    "onSelectService",
    "onAddNewCustomer",
    "onSelectPackage",
    "onSelectContactPoint",
    "onSelectSaleContact",
    "onChangeEscalationTemplate",
  ],
  mixins: [
    mixins,
    mixinsDatetime,
    mixinsValidator,
    mixinsObjectHelper,
    mixinsUser,
  ],
  data() {
    return {
      modalId: null,
      isValidateTrigger: false,
      isErrorOccurInMoleculeService: false,
      isErrorOccurAtOptionalIdcId: false,
      isErrorOccurAtSelectContactPoint: false,
      isErrorOccurAtSelectSaleContact: false,
      currentContractDetail: {
        contractId: null,
        additionalIds: [],
        status: "",
        customer: {
          customerId: "",
          customerName: "",
          mainAddress: {},
          billingAddress: {},
          mailingAddress: {},
        },
        isUserGenerated: false,
        generalServiceInfo: {
          siteId: "",
          contractStartDate: "",
          ipAddresses: [],
          otherTechnicalDetail: "",
        },
        packages: [
          {
            serviceId: "",
            packageId: "",
            packageQuantity: null,
            packagePeriodId: "",
            locationId: "",
            packageOptions: [],
            bundleNetwork: "",
            rack: [],
            domain: "",
            startDate: "",
            serviceNote: "",
            endDate: "",
            departmentId: null,
          },
        ],
        notes: "",
        contactPoints: [],
        saleContact: [],
        contractAttachments: [],
      },
    }
  },
  computed: {
    propContractDetail: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    currentContractForWatch() {
      return this.deepCopyObject(this.currentContractDetail)
    },

    isSelectedCustomer() {
      return this.hasString(this.currentContractDetail.customer.customerId)
    },

    isErrorOccur() {
      return (
        this.isErrorOccurAtOptionalIdcId ||
        this.isErrorOccurInMoleculeService ||
        this.isErrorOccurAtSelectContactPoint ||
        this.isErrorOccurAtSelectSaleContact
      )
    },
    hasCreatePermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTRACT_WRITE)
    },
    hasCreateCustomerPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CUSTOMER_WRITE)
    },
    hasReadTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_READ)
    },

    escalationSelected: {
      get() {
        return this.escalation
      },
      set(newValue) {
        this.$emit("onChangeEscalationTemplate", newValue)
      },
    },
  },
  watch: {
    selectedCustomerDetail: {
      deep: true,
      handler() {
        if (this.selectedCustomerDetail) {
          this.currentContractDetail.customer = this.deepCopyObject(
            this.selectedCustomerDetail
          )
        }
      },
    },
  },
  methods: {
    onUpdateGeneralServiceInfo(updateData) {
      const decoratedUpdateData = {
        siteId: updateData?.site?.siteId,
        contractStartDate: this.setTimeZone(updateData?.contractStartDate),
        ipAddresses: updateData?.ipAddresses,
        otherTechnicalDetail: this.getStringOrNull(
          updateData?.otherTechnicalDetail
        ),
      }
      this.currentContractDetail.generalServiceInfo = decoratedUpdateData
    },

    onUpdateContractPackages(updateData) {
      const decoratedUpdateData = updateData.map((item) => {
        return {
          serviceId: item.service?.serviceId,
          packageId: item.package?.packageId,
          packageQuantity: this.getNumberOrNull(item.packageQuantity),
          packagePeriodId: item.packagePeriod?.packagePeriodId,
          locationId: item.location?.locationId,
          packageOptions: this.decoratePackageOptions(item.packageOptions),
          bundleNetwork: item.bundleNetwork,
          rack: item.rack,
          domain: item.domain,
          startDate: this.setTimeZone(item.startDate),
          serviceNote: this.getStringOrNull(item.serviceNote),
          endDate: this.getStringOrNull(item.endDate),
          departmentId: this.getStringOrNull(item.departmentId),
        }
      })
      this.currentContractDetail.packages = decoratedUpdateData
    },

    decoratePackageOptions(packageOptions) {
      return packageOptions
        ? packageOptions.map((item) => {
            return {
              optionId: item.optionId,
              optionName: item.optionName,
              price: item.price,
              quantity: item.quantity,
            }
          })
        : []
    },

    onUpdateContactPoints(updateData) {
      const decoratedUpdateData = updateData.map((contact) => {
        return {
          contactPointId: contact.name.contactPointId,
          contactPointEmailId: contact.email.contactPointEmailId,
          contactPointPhoneId: contact.phone.contactPointPhoneId,
        }
      })
      this.currentContractDetail.contactPoints = decoratedUpdateData
    },

    onUpdateSaleContact(updateData) {
      const decoratedUpdateData = updateData.map((contact) => {
        return {
          contactPointId: contact.name.contactPointId,
          contactPointEmailId: contact.email.contactPointEmailId,
          contactPointPhoneId: contact.phone.contactPointPhoneId,
        }
      })
      this.currentContractDetail.saleContact = decoratedUpdateData
    },

    onClickCreateNewContractButton() {
      this.isValidateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccur) {
          this.modalId = "modal-confirm-create-new-contract"
          this.$bvModal.show(this.modalId)
        } else {
          this.toastWarning("Please Check Your Data")
        }
      })
    },
    onClickConfirmCreateNewContractFromModal() {
      this.$emit("onCreateNewContract", this.currentContractDetail)
      this.isValidateTrigger = false
      this.closeModal()
    },
    onClickCancelButton() {
      this.navigateTo("/internal/web-portal/idc")
    },
    onSelectCustomer(customerId) {
      this.$emit("onSelectCustomer", customerId)
    },
    onSelectService(selectedService) {
      this.$emit("onSelectService", selectedService)
    },
    onAddNewCustomer(newCustomerData) {
      this.$emit("onAddNewCustomer", newCustomerData)
    },
    onUpdateOptionalContractId(isUseOptionalContractId, optionalContractId) {
      this.$emit(
        "onUpdateOptionalContractId",
        isUseOptionalContractId,
        optionalContractId
      )
    },
    onSelectPackage(selectedPackage, selectedService) {
      this.$emit("onSelectPackage", selectedPackage, selectedService)
    },
    onSelectContactPoint(selectedContactPoint) {
      this.$emit("onSelectContactPoint", selectedContactPoint)
    },
    onClearSelectedContactPointId() {
      this.$emit("onClearSelectedContactPointId")
    },
    onSelectSaleContact(selectedSaleContact) {
      this.$emit("onSelectSaleContact", selectedSaleContact)
    },
    onClearSelectedSaleContactId() {
      this.$emit("onClearSelectedSaleContactId")
    },
    onRequestCreateNewContactPoint(newContactPointDetail) {
      this.$emit("onRequestCreateNewContactPoint", newContactPointDetail)
    },
    onUpdateContactPointProfilePicture(newProfilePicture) {
      this.$emit("onUpdateContactPointProfilePicture", newProfilePicture)
    },
    onRequestCreateNewSaleContact(newSaleContactDetail) {
      this.$emit("onRequestCreateNewSaleContact", newSaleContactDetail)
    },
    onUpdateSaleProfilePicture(newProfilePicture) {
      this.$emit("onUpdateSaleProfilePicture", newProfilePicture)
    },
    onSelectSite(selectedSite, updatedContractPackages) {
      this.onUpdateContractPackages(updatedContractPackages)
      this.$emit("onSelectSite", selectedSite)
    },

    // Emit update error from child components
    onUpdateErrorAtOptionalIdcId(isError) {
      this.isErrorOccurAtOptionalIdcId = isError
    },
    onUpdateErrorInMoleculeServiceDetail(isError) {
      this.isErrorOccurInMoleculeService = isError
    },
    onUpdateErrorAtMoleculeContactPoint(isError) {
      this.isErrorOccurAtSelectContactPoint = isError
    },
    onUpdateErrorAtMoleculeSaleContact(isError) {
      this.isErrorOccurAtSelectSaleContact = isError
    },

    navigateTo(path) {
      this.$router.push(path)
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
    getNumberOrNull(number) {
      return number ? Number(number) : null
    },
    getStringOrNull(text) {
      return this.hasString(text) ? text : null
    },
  },
}
</script>

<style lang="scss" scoped>
.select-customer-container,
.service-detail-container,
.contract-note-container,
.contact-point-container,
.sale-contact-container {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}

.card-padding {
  padding: 21px;
}

.card__header {
  margin-bottom: 14px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}
</style>
